import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash-es';
/*
 * Capitalizes the first letter of a string.
*/
@Pipe({name: 'status'})
export class StatusPipe implements PipeTransform {
  transform(value: any): string {
    if (isNil(value)) {
      return '';
    }
    value = value as string;

    const statusHash = {
      user_added : 'User Added',
      uploaded : 'Bulk Added',
      bad : 'Bad',
      verified : 'Verified',
      voter_file: 'External Service',
      action_network: 'Action Network',
      api: 'API'
    };

    return statusHash[value];

  }
}
